



































































import { Prop, Component, Vue } from 'vue-property-decorator'
import { TopicCompact, FileCompact } from '@/models'
import ListTopic from '@/views/Group/TopPage/NewFeed/ListTopic.vue'
import SharedFolderList from '@/views/Group/TopPage/SharedFolder/SharedFolderList.vue'
import { IPaging, ItemType } from './TopPage.vue'
import UserService from '@/services/UserService'
import { decodeHtml } from '@/helpers/Common'
//@ts-ignore
import _ from 'lodash'

/**
 * f2-001
 * グループTOP（分類ごと）
 */
@Component({
  components: {
    ListTopic,
    SharedFolderList
  }
})
export default class SortByClassPage extends Vue {
  @Prop() topics!: TopicCompact[]
  @Prop() files!: FileCompact[]
  @Prop() pageTopic!: IPaging
  @Prop() pageFile!: IPaging
  @Prop() startLoading!: boolean

  /**
   * emit load more for group topic
   */
  loadmoreTopic() {
    this.$emit('loadmoreTopic')
  }

  /**
   * emit load more for group shared folder
   */
  loadmoreFile() {
    this.$emit('loadmoreFile')
  }

  /**
   * Handle unread count
   */
  subtractReadCount() {
    this.$emit('subtractReadCount')
  }

  truncateText(text: string) {
    return _.truncate(text, {
      length: 50,
      separator: ' '
    })
  }
}
